import * as React from 'react'
import {useCallback, useMemo, useState} from 'react'
import {Hub} from 'yougile-model'
import {sharedBoardsEvents} from '@client/shared-boards-events'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {withUpdaters} from '@containers/updaters'
import {ListenerUpdater} from '@containers/updaters/listener-updater'
import {SyncUpdater} from '@containers/updaters/sync-updater'
import {Task} from '@extensions/task'
import {getTimerValue} from './get-timer-value'
import {TaskTimelinePopup} from './task-timeline-popup'
import {TaskTimelineSticker} from './task-timeline-sticker'

interface Props {
  task: Hub
}

const TaskTimelineBase = (props: Props) => {
  const {task} = props
  const [show, setShow] = useState(false)
  const timerValue = useMemo(() => getTimerValue(task), [task.id])
  const forceUpdate = useForceUpdate()

  useSyncEvent(
    'current',
    {filter: task.id},
    () => {
      forceUpdate()
    },
    []
  )

  const onShow = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setShow(true)
  }, [])

  const cb = useCallback(() => setShow(false), [])

  return (
    <>
      <TaskTimelineSticker
        task={task}
        onShow={onShow}
        timerValue={timerValue}
        isTaskColored={Task.isTaskColored(task)}
      />

      {show && (
        <TaskTimelinePopup task={task} timerValue={timerValue} close={cb} />
      )}
    </>
  )
}

export const TaskTimeline = withUpdaters(
  ListenerUpdater(sharedBoardsEvents),
  SyncUpdater({filter: '*', debounceTime: 2000, companyType: 'current'})
)((props: Props) => {
  return <TaskTimelineBase {...props} />
})
